import React, { useState } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
const DeleteButton = ({ url }) => {
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const toggleModal = () => setShowModal(!showModal);

  const handleDelete = async () => {
    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = await response.json();
      if (response.ok) {
        // Handle success, e.g., reload page or update UI
        toast.success(responseData.message);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else {
        responseData.error.forEach((error) => {
          toast.error(error);
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <React.Fragment>
      <button
        className="btn btn-sm btn-danger"
        onClick={() => setShowModal(true)}
      >
        <i className="bx bx-trash-alt"></i>Supprimer
      </button>

      <Modal isOpen={showModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Action</ModalHeader>
        <ModalBody>
          <p>Êtes-vous sûr de vouloir supprimer cet enregistrement?</p>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ backgroundColor: "#555B21" }}
            onClick={() => {
              handleDelete(), toggleModal();
            }}
          >
            Valider
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
      <ToastContainer />
    </React.Fragment>
  );
};

export default DeleteButton;
